import { render, staticRenderFns } from "./AxButton.vue?vue&type=template&id=d0742610&scoped=true"
import script from "./AxButton.vue?vue&type=script&lang=ts"
export * from "./AxButton.vue?vue&type=script&lang=ts"
import style0 from "./AxButton.vue?vue&type=style&index=0&id=d0742610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0742610",
  null
  
)

export default component.exports